async function clearCachesAndStorage(): Promise<void> {
  // Or a reload keeps serving the same broken build from the Cache API.
  try {
    if (typeof caches !== 'undefined') {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch (e) {
    console.warn('recovery: failed to clear Cache API', e);
  }

  // So they can't re-hydrate the caches.
  try {
    if (navigator.serviceWorker) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch (e) {
    console.warn('recovery: failed to unregister service workers', e);
  }

  // Also drops the JWT, forcing a fresh login.
  try { localStorage.clear(); } catch (e) { console.warn('recovery: localStorage.clear failed', e); }
  try { sessionStorage.clear(); } catch (e) { console.warn('recovery: sessionStorage.clear failed', e); }
}

export const recoveryUtils = {
  async hardReload(): Promise<void> {
    await clearCachesAndStorage();
    // Strip query/fragment so a corrupt deep link can't immediately re-crash us.
    const baseUrl = `${window.location.origin}/`;
    window.location.replace(baseUrl);
  }
};

if (typeof window !== 'undefined') {
  (window as any).recoveryUtils = recoveryUtils;
}
